import React from 'react';
import { createUseStyles, useTheme } from 'react-jss';
import { Theme } from '@app/theme';
import { CriterionStatusEnum } from 'queries';
import { useTranslation } from 'react-i18next';
import { CriterionStatusText } from './CriterionStatusText';

const useStyles = createUseStyles((theme: Theme) => ({
  questionGroup: {
    marginTop: theme.marginBase * 3,
  },
  question: {
    ...theme.fonts.caption,
    color: theme.colors.inkSecondary,
  },
  answer: {
    ...theme.fonts.body,
    marginTop: theme.marginBase / 2,
    overflow: 'auto',
  },
  disqualified: {
    color: theme.colors.redAccessible,
  },
  qualified: {
    color: theme.colors.greenAccessible,
  },
  outOfQuota: {
    color: theme.colors.yellowAccessible,
  },
  outOfQuotaSpan: {
    color: theme.colors.inkSecondary,
    textTransform: 'uppercase',
  },
}));

interface Props {
  question: string;
  answer: string | React.ReactNode | React.ReactNodeArray;
  criterionStatus?: CriterionStatusEnum;
}

export const QuestionAnswer = (props: Props) => {
  const theme: Theme = useTheme();
  const classes = useStyles({ theme });
  const { t } = useTranslation();
  return (
    <div className={classes.questionGroup} {...props}>
      <div className={classes.question}>{props.question}</div>
      <div className={classes.answer}>
        {typeof props.answer === 'string' ? (
          <CriterionStatusText criterionStatus={props.criterionStatus}>
            {props.answer}{' '}
            {props.criterionStatus === CriterionStatusEnum.OUT_OF_QUOTA ? (
              <span className={classes.outOfQuotaSpan}>
                [{t('sessions.details.monitoring.status.out_of_quota')}]
              </span>
            ) : (
              ''
            )}
          </CriterionStatusText>
        ) : (
          props.answer
        )}
      </div>
    </div>
  );
};
